// Sales payment and customer catalog (English).
window.PlummeI18n.register('en', {
  'inv.unknownAccount': 'Unknown account',
  'inv.refund.customerBalance': "Customer credit balance",
  'inv.refund.balanceHelp': "The balance includes the credit notes and the payments and refunds listed below.",
  'inv.refund.addFee': "Add fee",
  'inv.refund.businessFee': "Fee paid by the business",
  'inv.refund.customerReceives': "Customer receives",
  'inv.refund.accountDebit': "Total account debit",
  'sale.pay.ownerDebt': "Short-term debt to owners",
  'sale.pay.title': 'Payment',
  'sale.pay.help': 'Choose which account the sale was paid into, and on what date. Add a fee or split the payment into several instalments. The total must match the sales lines.',
  'sale.pay.paidTo': 'Paid to',
  'sale.pay.choosePaymentAccount': 'Choose payment account',
  'sale.create.needPaymentAccount': 'Choose Paid to before posting the sale.',
  'sale.pay.paidDate': 'Payment date',
  'sale.pay.fee': 'Fee',
  'sale.pay.addFee': 'Add fee',
  'sale.pay.removeFee': 'Remove fee',
  'sale.pay.partial': 'Instalments',
  'sale.pay.addPartial': 'Add instalment',
  'sale.pay.removePartial': 'Remove instalment',
  'sale.pay.seeTransaction': 'View transaction',
  'sale.pay.addAccount': 'Add account',
  'sale.pay.addCard': 'Add credit card',
  'sale.pay.addBankTitle': 'Add bank account',
  'sale.pay.addCardTitle': 'Add credit card',
  'sale.pay.addSolutionTitle': 'Add payment solution',
  'sale.pay.solution': 'Payment solution',
  'sale.pay.accountType': 'Account type',
  'sale.pay.cardOwner': 'The card belongs to',
  'sale.pay.displayName': 'Display name (optional)',
  'sale.pay.orgNumber': 'Company number',
  'sale.pay.openingBalance': 'Opening balance for reconciliation',
  'sale.pay.openingBalanceDate': 'Opening balance date',
  'sale.pay.resetChoice': 'Clear selection',
  'sale.cust.helpTitle': 'Customer on the sale',
  'sale.cust.help': 'Choose who the sale is for. Search for a saved customer, list or subscription — or press "New customer" to enter a recipient that is not saved yet. Name and address are pulled onto the document automatically.',
  'sale.cust.optionalHelp': 'A customer is optional on other sales. Turn it on if you want to link the sale to a specific customer.',
  'sale.cust.search': 'Search customers, lists and subscriptions...',
  'sale.cust.pickExisting': 'Choose existing',
  'sale.cust.new': 'New customer',
  'sale.cust.add': 'Add customer',
  'sale.cust.selected': 'Selected customer',
  'sale.cust.selectedList': 'Selected recipient list',
  'sale.cust.none': 'No customer selected yet',
  'sale.cust.listsAndSubs': 'Lists and subscriptions',
  'sale.cust.detailsTitle': 'Customer details',
  'sale.cust.name': 'Customer name',
  'sale.cust.namePh': 'E.g. Example Ltd',
  'sale.cust.number': 'Customer no.',
  'sale.cust.org': 'Company no.',
  'sale.cust.orgPh': '123 456 789',
  'sale.cust.address': 'Address',
  'sale.cust.addressPh': 'Street address, postal code and place',
  'sale.cust.email': 'Email',
  'sale.cust.emailPh': 'post@example.com',
  'sale.cust.phone': 'Phone',
  'sale.cust.phonePh': '400 00 000',
  'sale.cust.contacts': 'Contact persons',
  'sale.cust.noContacts': 'No contact persons added.',
  'sale.cust.addContact': 'Add contact person',
  'sale.cust.removeContact': 'Remove contact person',
  'sale.cust.contactName': 'Name',
  'sale.cust.contactNamePh': 'E.g. Jane Smith',
  'sale.cust.contactRole': 'Role',
  'sale.cust.contactRolePh': 'E.g. Accounts',
  'sale.cust.outstanding': 'Outstanding',
  'sale.cust.revenueToDate': 'Revenue to date',
  'sale.cust.pickPh': 'Customer or number',
  'sale.cust.select': 'Choose customer',
  'sale.cust.use': 'Use customer',
  'sale.cust.noEmail': 'No email on the customer',
  'sale.cust.listDefaultName': 'Customer list',
  'sale.cust.updatedToast': 'Customer updated on the sale',
  'sale.cust.noCustomerHelp': 'The sale is registered without a customer. Turn on the switch if you want to link it to a customer.',
  'sale.cust.selectHint': 'Choose a saved customer, list or subscription - or use New customer for free text.',
  'sale.cust.recipientsCount': '{count} recipients',
  'sale.cust.kindSubscription': 'Subscription',
  'sale.cust.kindList': 'List',
  'sale.cust.noMatches': 'No matches for "{query}".',
  'sale.cust.addAsNew': 'Add "{query}" as a new customer',
  'sale.cust.contactDefaultName': 'Contact person {n}',
  'sale.cust.saveFailed': 'Could not save the customer.',
  'sale.pay.accountNameSavings': 'Savings account',
  'sale.pay.accountNameOperating': 'Operating account',
  'sale.pay.accountNamePrivate': 'Private account',
  'sale.pay.accountNameBank': 'Bank account',
  'sale.pay.groupBank': 'Bank accounts',
  'sale.pay.groupCard': 'Credit cards',
  'sale.pay.groupPrivate': 'Private',
  'sale.pay.groupOther': 'Other',
  'sale.pay.groupGeneric': 'Accounts',
  'sale.pay.cashLabel': 'Cash',
  'sale.pay.bankNameRequired': 'Give the bank account a name',
  'sale.pay.accountOrCardNameRequired': 'Give the account or card a name',
  'sale.pay.accountNumberRequired': 'Enter the account number',
  'sale.pay.bankAccountAdded': 'Bank account added',
  'sale.pay.privateAccountAdded': 'Private account added',
  'sale.pay.saveAccountFailed': 'Could not save the account.', 'sale.pay.accountsUnavailable': 'Payment accounts are not connected to the backend.', 'sale.pay.openingSetupRequired': 'Enter the opening date and opening balance. Enter 0 if the balance was zero.', 'sale.pay.invalidLedgerAccount': 'A valid account number is missing from the chart of accounts.', 'sale.pay.accountExists': 'Account {code} already exists.',
  'sale.pay.typePrivateCard': 'Private account / card',
  'sale.pay.newBankAccountNote': 'A new bank account is created in the chart of accounts',
  'sale.pay.newPrivateAccountNote': 'A new private account/card is created in the chart of accounts',
  'sale.pay.bankAccountSeriesInfo': 'Bank accounts get the next available account in the 192x series.',
  'sale.pay.privateAccountSeriesInfo': 'Private cards/accounts get the next available interim account in the 206x series.',
  'sale.pay.thisGetsAccount': 'This gets account',
  'sale.pay.accountNameLabel': 'Account name',
  'sale.pay.accountOrCardNameLabel': 'Name of account / card',
  'sale.pay.accountNamePhBank': 'E.g. Operating account 2',
  'sale.pay.accountNamePhPrivate': 'E.g. Owner card Visa',
  'sale.pay.accountNumberLabel': 'Account number',
  'sale.pay.accountCardRefLabel': 'Account / card number / reference (optional)',
  'sale.pay.interimAccountPrefix': 'Interim account',
  'sale.pay.cardNameRequired': 'Give the credit card a name',
  'sale.pay.cardNumberRequired': 'Enter the card/account number',
  'sale.pay.openingBalanceRequired': 'Enter the opening balance and opening balance date',
  'sale.pay.creditCardDebtPrefix': 'Credit card debt',
  'sale.pay.cardAdded': 'Credit card added',
  'sale.pay.saveCardFailed': 'Could not save the credit card.',
  'sale.pay.scopeBusiness': 'Business',
  'sale.pay.businessCardNote': 'Business cards are posted as separate card debt',
  'sale.pay.privateCardNote': 'Private cards are posted as an interim account',
  'sale.pay.businessCardSeriesInfo': 'Business cards that are not bank accounts get the next available account in the 238x series.',
  'sale.pay.privateCardSeriesInfo': 'Private cards get the next available interim account in the 206x series.',
  'sale.pay.accountInLedger': 'Account in accounts:',
  'sale.pay.cardNamePhBusiness': 'E.g. Company card Visa',
  'sale.pay.cardNamePhPrivate': 'E.g. Owner card Mastercard',
  'sale.pay.cardNumberLabel': 'Card number / account number',
  'sale.pay.cardNumberLabelOptional': 'Card number / account number (optional)',
  'sale.pay.otherSolution': 'Other payment solution',
  'sale.pay.settlementPrefix': 'Settlement',
  'sale.pay.solutionAdded': 'Payment solution added',
  'sale.pay.saveSolutionFailed': 'Could not save the payment solution.',
  'sale.pay.solutionExplainer': 'Vipps, PayPal, iZettle, Stripe and similar are posted to a separate settlement account for the payment solution, which is reconciled once the settlement is paid out to the bank account.',
  'sale.pay.addCardAction': '+ Add credit card ...',
  'sale.pay.addSolutionAction': '+ Add payment solution ...',
  'sale.pay.partialLabel': 'Instalment {n}',
  'sale.pay.partialStatusRemaining': 'remaining',
  'sale.pay.partialStatusTooMuch': 'too much',
  'sale.pay.partialStatusMatches': 'matches',
  'sale.pay.partialSummary': 'Paid {paid} of {expected} · {status}',
  'sale.pay.partialMismatch': 'The sum of the instalments must match the sale total{feeSuffix} ({expected}).', 'sale.list.noMembers': 'The list has no customers to invoice.', 'sale.list.customerMissing': 'The customer no longer exists.', 'sale.list.noneCreated': 'No invoices were created.', 'sale.list.missingEmailNotice': '{count} invoices were created for customers without an email address and must be sent or printed manually: {names}', 'sale.list.notCreatedNotice': 'Not completed for: {names}', 'sale.list.createdNoEmail': 'The invoice was created, but the customer has no email address. Send or print it manually.', 'sale.list.noneSent': 'The invoices were created, but none were sent by email. Send or print them manually: {names}', 'sale.list.recipientsCount': '{count} recipients', 'sale.list.sentPartly': 'Sent to {sent} recipients. Not sent: {names}', 'sale.list.sentAll': 'Sent to {sent} recipients.',
  'sale.pay.partialMismatchFeeSuffix': ' less the fee', 'sale.pay.feeTooHigh': 'The fee cannot be larger than the sale ({gross}).', 'sale.pay.splitMismatchError': 'The instalments ({paid}) must add up to the sale total less the fee ({expected}).', 'sale.product.backendUnavailable': 'Product saving is not connected to the backend.', 'sale.product.added': 'Product "{name}" added', 'sale.product.updated': 'Product "{name}" updated', 'sale.product.saveFailed': 'Could not save the product.', 'sale.create.backendUnavailable': 'New sale is not connected to the backend.',
});

